import { useEffect, useState } from 'react'
import { Delete } from 'lucide-react'

/** De PIN-popup: alleen cijfers, groot, met trillen bij een fout. */
export function PinPad({ lengte, bezig, fout, klaar }: {
  lengte: number; bezig: boolean; fout: string | null; klaar: (pin: string) => void
}) {
  const [pin, zet] = useState('')
  const [schud, zetSchud] = useState(false)

  useEffect(() => {
    if (!fout) return
    zet('')
    zetSchud(true)
    navigator.vibrate?.([80, 60, 80])
    const t = setTimeout(() => zetSchud(false), 450)
    return () => clearTimeout(t)
  }, [fout])

  const druk = (c: string) => {
    if (bezig) return
    const nieuw = (pin + c).slice(0, lengte)
    zet(nieuw)
    if (nieuw.length === lengte) klaar(nieuw)
  }

  useEffect(() => {
    const k = (e: KeyboardEvent) => {
      if (/^\d$/.test(e.key)) druk(e.key)
      else if (e.key === 'Backspace') zet((p) => p.slice(0, -1))
    }
    document.addEventListener('keydown', k)
    return () => document.removeEventListener('keydown', k)
  })

  return (
    <div>
      <div className={`pin-stippen ${schud ? 'schud' : ''}`} aria-label={`${pin.length} van ${lengte} cijfers`}>
        {Array.from({ length: lengte }, (_, i) => <i key={i} className={i < pin.length ? 'vol' : ''} />)}
      </div>
      <div className="pin-toetsen">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((c) => (
          <button key={c} className="pin-toets" onClick={() => druk(c)} disabled={bezig}>{c}</button>
        ))}
        <span className="pin-toets leeg" />
        <button className="pin-toets" onClick={() => druk('0')} disabled={bezig}>0</button>
        <button className="pin-toets" onClick={() => zet((p) => p.slice(0, -1))} aria-label="Wissen" disabled={bezig}><Delete size={28} /></button>
      </div>
    </div>
  )
}
